// extracted by mini-css-extract-plugin
export default {"root":"side_filters-module___root___a2e2fb12","section":"side_filters-module___section___ade45e7c"};